import { Component, DoCheck, Input, OnInit, ViewChild } from '@angular/core';
import { IonInfiniteScroll, ModalController, Platform } from '@ionic/angular';
import { AlertService, AuthenticationService } from 'src/app/shared/_services';
import { TransactionDetailsPage } from 'src/app/shared/modals/transaction-details/transaction-details.page';
import { FilterTransactionsPage } from 'src/app/shared/modals/filter-transactions/filter-transactions.page';
import { Router } from '@angular/router';
import * as pdfmake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { DatePipe, DecimalPipe } from '@angular/common';
import { DashboardStore, TransactionsStore } from 'src/app/shared/_services/store';
import { ReceiptService } from 'src/app/shared/_services/receipt.service';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.page.html',
  styleUrls: ['./transactions.page.scss'],
  providers: [File, DatePipe, DecimalPipe]
})
export class TransactionsPage implements OnInit, DoCheck {
  @Input() transactionDetail: any;
  @ViewChild(IonInfiniteScroll, { static: false })
  infiniteScroll: IonInfiniteScroll;
  pickerDate = this.dashboardStore.getPickerDate();
  offset: any;
  queryString = '';
  transactionDate = new Date(this.pickerDate).toDateString();
  currentUser: any;
  currentUserName = this.dashboardStore.getCurrentUserName();
  transactionCount = parseInt(this.transactionsStore.getTransactionCount(), 10);
  transactionDetails = [];
  newTransactionDetails = [];
  searchText: any;
  subscription: any;
  bankTransferCount = this.dashboardStore.getBankTransferCount();
  ussdCount = this.dashboardStore.getUssdCount();
  bankTransferCountArray: any = [];
  ussdCountArray: any = [];
  bankTransferDownload = [];
  ussdDownload = [];
  docRows = [];
  docDefinition: any;
  pdfFile: any;
  initiatedBy: string;
  description: string;
  finalTimeGenerated: string;
  fileName: string;
  android: boolean;
  payer: any;
  status: any;
  transactionAmount: any;
  paymentMethod: string;
  paymentRef: string;
  transactionRef: string;
  accountNumber: string;
  doneLoading = false;
  i = 1;

  constructor(
    private router: Router,
    private platform: Platform,
    private datePipe: DatePipe,
    private fileOpener: FileOpener,
    private decimalPipe: DecimalPipe,
    private alertService: AlertService,
    private auth: AuthenticationService,
    private dashboardStore: DashboardStore,
    private receiptService: ReceiptService,
    private modalController: ModalController,
    private transactionsStore: TransactionsStore
  ) {
    this.currentUser = this.auth.currentUserValue;
  }

  highlightResult(ev: any) {
    this.searchText = ev.target.value;
  }

  async filterTransactions() {
    const modal = await this.modalController.create({
      component: FilterTransactionsPage,
      backdropDismiss: true,
      showBackdrop: true,
      swipeToClose: true,
      // mode: 'ios',
      cssClass: 'bottom-modal create-dispute filter-trans-modal',
    });
    return await modal.present();
  }

  async openTransactionDetails(transactionDetail: any) {
    console.log(transactionDetail);
    const modal = await this.modalController.create({
      component: TransactionDetailsPage,
      backdropDismiss: true,
      showBackdrop: true,
      swipeToClose: true,
      // mode: 'ios',
      cssClass: 'bottom-modal create-dispute',
      componentProps: { transactionDetail },
    });
    return await modal.present();
  }

  getTransactionTypeCount() {
    if (this.transactionDetails.length > 0) {
      this.transactionDetails.forEach((transactionDetail) => {
        if (transactionDetail.virtualAccount) {
          this.bankTransferCountArray.push(parseFloat(transactionDetail));
        }
        if (transactionDetail.ussdString) {
          this.ussdCountArray.push(parseFloat(transactionDetail));
        }
      });
      console.log(
        this.bankTransferCountArray.length,
        this.ussdCountArray.length
      );
      this.bankTransferCount = this.bankTransferCountArray.length;
      this.ussdCount = this.ussdCountArray.length;

      this.dashboardStore.setBankTransferCount(this.bankTransferCount);
      this.dashboardStore.setUssdCount(this.ussdCount);
    } else {
      this.bankTransferCount = '0';
      this.ussdCount = '0';

      this.dashboardStore.setBankTransferCount(this.bankTransferCount);
      this.dashboardStore.setUssdCount(this.ussdCount);
    }
  }

  getTransactions() {
    this.auth
      .getTransactions(
        this.pickerDate,
        20,
        this.offset,
        this.bankTransferCount,
        this.ussdCount,
        this.queryString
      )
      .subscribe(
        (response: any) => {
          console.log(response);
          this.transactionCount = response.count;
          this.storeTransactionDetails(response.transaction);
          setTimeout(() => {
            this.getTransactionTypeCount();
          }, 150);
          this.bankTransferCountArray = [];
          this.ussdCountArray = [];
        },
        (error) => {
          console.error(error);
        }
      );
  }

  loadMoreTransactions(ev: any) {
    this.getTransactions();
    setTimeout(() => {
      console.log('Done');
      this.doneLoading = true
        ? ev.target.complete()
        : (this.doneLoading = false);

      if (this.transactionDetails.length === this.transactionCount) {
        ev.target.disabled = true;
      }
    }, 1000);
  }

  refreshTransactions(event: any) {
    console.log('Refreshing to get all transactions');
    this.auth
      .getTransactions(
        this.pickerDate,
        20,
        this.offset,
        this.bankTransferCount,
        this.ussdCount,
        this.queryString
      )
      .subscribe(
        (response: any) => {
          console.log('Transactions updated', response);
          event.target.complete();
          this.storeTransactionDetails(response.transaction);
        },
        (error) => {
          event.target.complete();
        }
      );
  }

  storeTransactionDetails(response: any) {
    this.newTransactionDetails = response;
    const updatedTransactionDetails = this.transactionDetails.concat(
      this.newTransactionDetails
    );
    this.transactionDetails = this.sortArray(
      updatedTransactionDetails,
      'createdAt'
    );
    console.log(this.transactionDetails);

    this.transactionsStore.setTransactionDetails(this.transactionDetails);
    this.transactionDetails = this.transactionsStore.getTransactionDetails();
    this.doneLoading = true;
  }

  sortArray(array: any, createdAt: string | number) {
    return array.sort(
      (a: any, b: any) => Date.parse(b[createdAt]) - Date.parse(a[createdAt])
    );
  }

  downloadReport() {
    if (this.transactionDetails.length !== 0) {
      let noRefresh: any;
      if (!this.platform.is('android') || !this.platform.is('ios')) {
        noRefresh = 'Please do not refresh this page until file is downloaded';
      } else {
        noRefresh = '';
      }
      this.alertService.loading('Generating report... ' + noRefresh);
      this.auth
        .getTransactions(
          this.pickerDate,
          this.transactionCount,
          this.offset,
          this.bankTransferCount,
          this.ussdCount,
          this.queryString
        )
        .subscribe(
          (response: any) => {
            console.log('Report generated', response);
            this.storeTransactionDetails(response.transaction);
            this.infiniteScroll.disabled = true;
            this.getOtherDetails();
            setTimeout(() => {
              // Official PDFMake Docs  https://pdfmake.github.io/docs/0.1/
              const self = this;
              pdfmake.vfs = pdfFonts.pdfMake.vfs;
              this.docRows.push([
                { text: 'Serial No.', style: 'boldCenter' },
                { text: 'Transaction Time', style: 'boldCenter' },
                { text: 'Amount', style: 'boldCenter' },
                { text: 'Payment Method', style: 'boldCenter' },
                { text: 'Virtual Account/USSD Code', style: 'boldCenter' },
                { text: 'Payer', style: 'boldCenter' },
                { text: 'Description', style: 'boldCenter' },
                { text: 'Initiated By', style: 'boldCenter' },
                { text: 'Status', style: 'boldCenter' },
              ]);
              for (const transactionDetail of this.transactionDetails) {
                console.log(transactionDetail);
                this.transactionDate = this.datePipe.transform(
                  transactionDetail.createdAt,
                  'h:mm a'
                );
                this.transactionAmount = this.decimalPipe.transform(
                  transactionDetail.amount,
                  '1.2-2'
                );

                if (this.currentUser.role === 'merchant') {
                  this.initiatedBy = transactionDetail.cashier.name;
                } else if (this.currentUser.role === 'cashier') {
                  this.initiatedBy = this.currentUser.details.name;
                }
                if (transactionDetail.virtualAccount) {
                  this.paymentMethod = 'Bank Transfer';
                  this.accountNumber = transactionDetail.virtualAccount;
                  transactionDetail.notification.narration === null ||
                  transactionDetail.notification.narration === ''
                    ? (this.description = 'N/A')
                    : (this.description =
                        transactionDetail.notification.narration);
                  if (
                    transactionDetail.notification.senderAccountName === null
                  ) {
                    this.status = 'Incomplete';
                    this.payer = 'N/A';
                  } else {
                    this.status = 'Successful';
                    this.payer =
                      transactionDetail.notification.senderAccountName;
                  }
                } else {
                  this.paymentMethod = 'USSD';
                  this.accountNumber = transactionDetail.ussdString;
                  this.paymentRef = transactionDetail.paymentRef;
                  this.transactionRef = transactionDetail.transactionRef;
                  transactionDetail.narration === null ||
                  transactionDetail.narration === '' ||
                  !transactionDetail.narration
                    ? (this.description = 'N/A')
                    : (this.description = transactionDetail.narration);
                  if (transactionDetail.payerPhone === null) {
                    this.status = 'Incomplete';
                    this.payer = 'N/A';
                  } else {
                    this.status = 'Successful';
                    this.payer = transactionDetail.payerPhone;
                  }
                }
                this.docRows.push([
                  { text: this.i++, style: 'rowpad', alignment: 'center' },
                  { text: this.transactionDate, style: 'rowpad' },
                  { text: 'N' + this.transactionAmount, style: 'rowpad' },
                  { text: this.paymentMethod, style: 'rowpad' },
                  { text: this.accountNumber, style: 'rowpad' },
                  {
                    text:
                      this.payer.length > 15
                        ? this.payer.substring(0, 20).concat('...')
                        : this.payer,
                    style: 'rowpad',
                  },
                  {
                    text:
                      this.description.length > 15
                        ? this.description.substring(0, 15).concat('...')
                        : this.description,
                    style: 'rowpad',
                  },
                  { text: this.initiatedBy, style: 'rowpad' },
                  { text: this.status, style: 'rowpad' },
                ]);
              }
              this.docDefinition = {
                content: [
                  {
                    text: this.currentUserName || this.currentUser.details.name,
                    style: 'name',
                  },
                  {
                    text:
                      'Report for ' + new Date(this.pickerDate).toDateString(),
                    style: 'reportdate',
                  },
                  {
                    image:
                      // tslint:disable-next-line:max-line-length
                      'data:image/png;base64,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',
                    margin: [0, -80, 0, 80],
                    alignment: 'right',
                    fit: [100, 100],
                  },
                  {
                    layout: 'lightHorizontalLines',
                    table: {
                      headerRows: 1,
                      widths: 'auto',
                      body: this.docRows,
                    },
                  },
                ],
                styles: {
                  rowpad: {
                    margin: [0, 10],
                    alignment: 'center',
                  },
                  name: {
                    fontSize: 20,
                    margin: [0, 10],
                  },
                  reportdate: {
                    fontSize: 16,
                    margin: [0, 20],
                  },
                  boldCenter: {
                    bold: true,
                    alignment: 'center',
                  },
                },
                defaultStyle: {
                  font: 'Rubik',
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
              };
              pdfmake.fonts = {
                Rubik: {
                  normal:
                    'https://cdn.jsdelivr.net/npm/rubik-font@0.0.3/fonts/Rubik-Light.ttf',
                  bold: 'https://cdn.jsdelivr.net/npm/rubik-font@0.0.3/fonts/Rubik-Medium.ttf',
                },
                Roboto: {
                  normal:
                    'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
                  bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
                },
              };

              if (this.docRows.length - 1 === response.count) {
                this.pdfFile = pdfmake.createPdf(this.docDefinition);
              } else {
                this.docRows = this.docRows.pop();
                console.log('New length ', this.docRows.length - 1);
                setTimeout(() => {
                  this.pdfFile = pdfmake.createPdf(this.docDefinition);
                }, 1000);
              }

              this.receiptService.openInDevice(this.pdfFile, this.fileName, 'Report');

              this.docRows = [];
              this.i = 1;
            }, 1000);
          },
          (error) => {
            this.alertService.stopLoading();
            console.log(error);
          }
        );
    } else {
      this.alertService.retry('No transactions found', 3000, true);
    }
  }

  // saveToDevice(data: any, savefile: any) {
  //   this.receiptService.saveToDevice()
  // }

  getOtherDetails() {
    const date = new Date(Date.now()).toString().slice(0, -37);
    const timeGenerated = date.replace(':', '.');
    this.finalTimeGenerated = timeGenerated.replace(':', '.');
    this.fileName = 'Bank3D Transaction_' + this.finalTimeGenerated + '_.pdf';
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  ionViewWillEnter() {
    this.offset = 0;
    this.transactionDetails = this.transactionsStore.getTransactionDetails();
    document.title = 'Transactions | Bank3D';
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(
      99999,
      () => {
        this.goBack();
      }
    );
  }

  ionViewDidLeave() {
    this.transactionsStore.setFilterQueryString('');
    this.subscription.unsubscribe();
  }

  ngOnInit() {}

  ngDoCheck() {
    if (
      this.transactionsStore.getIsFilterApplied() === 'true' ||
      this.transactionsStore.getIsTransactionResolved() === 'true'
    ) {
      this.pickerDate = this.dashboardStore.getPickerDate();
      this.transactionDate = new Date(this.pickerDate).toDateString();
      this.transactionDetails = this.transactionsStore.getTransactionDetails();

      this.bankTransferCount = this.dashboardStore.getBankTransferCount();
      this.ussdCount = this.dashboardStore.getUssdCount();
      this.transactionCount = parseInt(
        this.transactionsStore.getTransactionCount(),
        10
      );

      this.transactionsStore.setIsFilterApplied(false);
      this.transactionsStore.setIsTransactionResolved(false);

      this.queryString = this.transactionsStore.getFilterQueryString();
      this.infiniteScroll.disabled = false;
    }
  }
}
